import React from 'react';

import NextImage, { ImageLoader, ImageProps } from 'next/image';

import { buildImageProxyUrl } from '@repo/utils/url';

import { STRAPI_CONTENT_URL } from 'strapi/constants';

export const IMAGE_PROXY_PROVIDER = 'imageProxyProvider';

// Usually Strapi images are stored on our own CDN (cms-cdn)
// We need this loader to prevent usage of Next.js default loader for images that are already use our CDN
const CMSCDNLoader: ImageLoader = ({ src }) => {
  return src;
};

// Custom loader for IMAGE_PROXY_PROVIDER
// Needed to build proper URLs for images using our main content URL
const imageProxyLoader: ImageLoader = ({ src, width }) => {
  return buildImageProxyUrl(src, { width, height: width });
};

const LandingImage: React.FC<ImageProps & { provider?: string }> = (props) => {
  // Some of our Strapi component use images from 'public' folder
  // We keep provider empty there
  if (!props.provider) {
    return <NextImage {...props} />;
  }

  // Fix for local environment
  // Local strapi uses 'local' as provider
  if (props.provider === 'local') {
    return <NextImage {...props} src={`${STRAPI_CONTENT_URL}${props.src}`} />;
  }

  // Custom provider. Not coming from Strapi. We must set this value manually if needed
  // (for example in useMockupsGroupGrid.ts)
  if (props.provider === IMAGE_PROXY_PROVIDER) {
    return <NextImage loader={imageProxyLoader} {...props} />;
  }

  // Images with a proper provider field are coming from our CDN
  return <NextImage loader={CMSCDNLoader} {...props} />;
};

export default LandingImage;
